import styled from 'styled-components'

export const TouristDisturbanceGraphContainer = styled.div`
  .chart-content {
    background-color: #f1f8ff;
    padding: 20px;
    border-radius: 10px;
  }
`
